
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoySparWest as ObiBuoySparWestElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-spar-west.js';
 
 
 

 
 export const ObiBuoySparWest = createComponent({
   react: React,
   tagName: 'obi-buoy-spar-west',
   elementClass: ObiBuoySparWestElement,
   events: {
     
   }
  });
 
 